var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrInsurancePagePdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "2.01rem",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M55 18H42V5a1 1 0 0 0-1-1H13a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h27v16H13a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h42a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 20,
    x: 8,
    y: 32,
    fill: "#ef5350",
    rx: 1,
    ry: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m55.71 18.29-14-14A1 1 0 0 0 40 5v14a1 1 0 0 0 1 1h14a1 1 0 0 0 .71-1.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 46v-8h2.66a2.8 2.8 0 0 1 1.9.58 2.42 2.42 0 0 1 .83 1.92 2.54 2.54 0 0 1-.39 1.32 2.19 2.19 0 0 1-1 .88 2.67 2.67 0 0 1-1.15.23h-1.2V46zm1.69-4.52h.94a1.14 1.14 0 0 0 .81-.28 1 1 0 0 0 .29-.76q0-.92-1.1-.92h-.94zM21.95 46v-8h3a3.18 3.18 0 0 1 2.08.68A4 4 0 0 1 28.5 42a4.48 4.48 0 0 1-.5 2.11 3.52 3.52 0 0 1-1.4 1.45 4.54 4.54 0 0 1-2.22.44zm1.69-1.52h1.08a1.93 1.93 0 0 0 1.09-.29 2.53 2.53 0 0 0 1-2.26 2.4 2.4 0 0 0-.95-2.12 1.87 1.87 0 0 0-1.08-.29h-1.14zm6.6 1.52v-8h4.58v1.52h-2.89v1.63h2.65v1.52h-2.65V46z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrInsurancePagePdfIcon);
export default __webpack_public_path__ + "static/media/qr-insurance-page-pdf-icon.2e01c76f8488888409afcf9f7123a153.svg";
export { ForwardRef as ReactComponent };